export class PhysiqueChimieInSitu {
    id: number; // For IndexedDB
    interventionId: number;

    IsMandatory: boolean;
    TemperatureEau: number;
    TemperatureEauCorrigee: number;
    TemperatureAir: number;
    pH: number;
    Conductivite: number;
    OxygeneDissous: number;
    SaturationO2d: number;

    SondePh: string;
    SondeConductivite: string;
    SondeOxygene: string;
    SondeEau: string;
    COFRACTemperatureEau: boolean;
    COFRACpH: boolean;
    COFRACConductivite: boolean;
    COFRACOxygeneDissous: boolean;
    COFRACSaturationO2d: boolean;

    static mapFromJSON(json: any): PhysiqueChimieInSitu {
        const p = new PhysiqueChimieInSitu();

        p.IsMandatory = json.isMandatory;
        p.TemperatureEau = json.temperatureEau;
        p.TemperatureAir = json.temperatureAir;
        p.pH = json.ph;
        p.Conductivite = json.conductivite;
        p.OxygeneDissous = json.oxygeneDissous;
        p.SaturationO2d = json.saturationO2d;
        p.SondeConductivite = json.sondeConductivite;
        p.SondeEau = json.sondeEau;
        p.SondeOxygene = json.sondeOxygene;
        p.SondePh = json.sondePh;

        p.COFRACConductivite = json.cofracConductivite;
        p.COFRACOxygeneDissous = json.cofracOxygeneDissous;
        p.COFRACSaturationO2d = json.cofracSaturationO2d;
        p.COFRACTemperatureEau = json.cofracTemperatureEau;
        p.COFRACpH = json.cofracPH;

        return p;
    }
}
